import React from 'react';
import { connect } from 'react-redux';

import { updateGlove } from '../../actions/creators';
import ColorButtons from '../ColorButtons';

const Binding = ({
  colors,
  currentColor,
  onColorClick,
}) => (
  <div className="step-item-view-wrap pull-right">
    <ColorButtons
      title="BINDING COLOR"
      className="binding-color-wrap"
      colors={colors}
      currentColor={currentColor}
      onClick={onColorClick}
    />
  </div>
);

const mapStateToProps = (state) => {
  const { bindingColor } = state.glove;
  const allColors = state.builder.leatherColors[state.glove.leatherGrade.id].filter(o => o.url === undefined || o.url === null);
  return {
    colors: allColors,
    currentColor: bindingColor,
  };
};

const mapDispatchToProps = dispatch => ({
  onColorClick: color => dispatch(updateGlove({ bindingColor: color })),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Binding);
